import { Component, OnInit } from '@angular/core';
import { CreatePlaylistForm } from '../../../models/';
import { SongsService, PlaylistService,ScrollService, MessagesServices } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import * as _ from 'lodash';
import { MdDialogRef } from '@angular/material';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Globals } from '../../app.globals';

@Component({
  selector: 'edit-playlist',
  templateUrl: './create-que-playlist.component.html',
  styleUrls: ['./create-que-playlist.component.css']
})
export class CreateQuePlaylistComponent implements OnInit {
  private image: any;
  private model: CreatePlaylistForm;
  private songs: Array<any> = new Array<any>();
  private isImageChanged: boolean = false;
  public playlist: any;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
    public toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],

        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ];
    public editorConfig = {
        placeholder: "Full description",
        modules: {
            toolbar: this.toolbarOptions
        },
        theme: 'snow'
    };

    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(private scrollService: ScrollService,private router: Router,public dialogRef: MdDialogRef<CreateQuePlaylistComponent>, private sm: MessagesServices, private songsService: SongsService,
    private playlistService: PlaylistService, private toastyService: ToastyService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});

        this.model = new CreatePlaylistForm();
    //getting messages from db
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {


      this.playlist.forEach(element => {
          this.songs.push(element.metaData);
      });
      this.image= (this.playlist[0].metaData.album != null && this.playlist[0].metaData.album.image != null && this.playlist[0].metaData.album.image.trim() !== '')
          ? this.playlist[0].metaData.album.image : (this.playlist[0].metaData.artist != null && this.playlist[0].metaData.artist.image != null &&
          this.playlist[0].metaData.artist.image.trim() !== '' && this.playlist[0].metaData.artist.image != null ?
          this.playlist[0].metaData.artist.image : new Globals().domain + '/images/artist_default_avatar.jpg');
      this.model.visibility= "Public";
  }

  /**
  * setting system messages
  **/

  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_PLAYLIST_CREATED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
        }
      }

    }
  }
  saveChanges() {
    //this.setMessages();
      this.blockUI.start('Loading, please wait...');
      if(this.onlineOffline1){
    this.playlistService.createQuePlaylistWithSongs(this.model,this.songs).subscribe((res) => {
      if (this.isImageChanged) {
        let image = this.image.replace(/^data:image\/(png|jpeg);base64,/, '');
        this.playlistService.updatePlaylistAvatar(res.id, image).subscribe((result) => {

        });
      }
        let toastOptions: ToastOptions = {
            title: this.title1,
            msg: "Playlist created.",
            showClose: true,
            timeout: 2000,
            theme: 'default'
        };
        this.toastyService.success(toastOptions);
        this.blockUI.stop();
        this.dialogRef.close(true);
        this.closeSideNav();
        this.router.navigate(['/playlist/'+res.slug]);
    });
      }
  }

  fileChangeListener($event) {
    this.image = new Image();
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    let that = this;
    myReader.onloadend = function (loadEvent: any) {
      that.image = loadEvent.target.result;
      that.isImageChanged = true;
    };
    myReader.readAsDataURL(file);
  }

  private onDropModel(args) {
    let newOrder = [];
    let i = 0;
    this.songs.forEach((arrayItem) => {
      let song: any = {};
      let tmp: any = _.pick(arrayItem, ['id']);
      song.song_id = tmp.id;
      song.order = i;
      i++;
      newOrder.push(song);
    });
    this.playlistService.setNewSongsOrder(this.model.id, newOrder).subscribe((res) => {
    });
  }

    closeSideNav() {
        this.scrollService.closeSideNav();
    }

}



// WEBPACK FOOTER //
// ./src/app/playlists/create-que-playlist/create-que-playlist.component.ts